import { autobind } from 'core-decorators';
import { BaseController } from '@Controller';
import Middle from './middle/middle.vue';
import Left from './left.vue';
import LandFeature from '../components/LandFeature'; // 地块图形组件

@autobind
class MainController extends BaseController {
    constructor(MixMapModule) {
        super();
        this.MixMapModule = MixMapModule;
    }

    static getConfig() {
        return {};
    }

    static getVMConfig(config, self) {
        return {
            data() {
                return {
                    ...config,
                    monitorList: [],
                    monitorRangeList: [],
                    contentType: 1,
                };
            },
        };
    }

    static getInput() {
        return {
            map: {
                renderFun: 'renderMap',
            },
        };
    }

    static getOutput(self) {
        return {
            Left: {
                component: Left,
                attribute() {
                    return {
                        props: {
                            onDataSuccess: self._onLeftData,
                        },
                        on: {
                            treeChildreClick: (data) => {
                                let { latitude, longitude } = data;
                                if (latitude && longitude) {
                                    longitude = Number(longitude);
                                    latitude = Number(latitude);
                                    self.MixMapModule.toCenter([longitude, latitude]);
                                }
                                // 地图对应的地块闪烁
                                self.vm.$refs.LandFeature.selectFeatureById(data.id);
                            },
                        },
                    };
                },
            },
            Middle: {
                component: Middle,
                attribute() {
                    let attr = {
                        props: {
                            renderMap: self.renderMap,
                            monitorList: self.vm.monitorList,
                            type: self.vm.contentType,
                        },
                        on: {
                            changeContentType(val) {
                                // 地图模式、图册模式类型切换事件，val的值1 ：地图 val的值2 :图册
                                self.vm.contentType = val;
                            },
                        },
                    };
                    return attr;
                },
            },
            LandFeature: {
                component: LandFeature,
                attribute() {
                    return {
                        props: {
                            rangeData: self.vm.monitorRangeList,
                            idKey: 'monitorId',
                        },
                        ref: 'LandFeature',
                    };
                },
            },
        };
    }

    // eslint-disable-next-line class-methods-use-this
    _onLeftData(data) {
        console.log(data);
        this.vm.monitorList = data || [];
        let rangeList = [];
        data.forEach((item) => {
            let range = item.monitorRange;
            if (range) {
                range = JSON.parse(range);
                range.forEach((rangeItem) => {
                    rangeItem.monitortId = item.id;
                });
                rangeList = rangeList.concat(range);
            }
        });
        console.log(rangeList);
        this.vm.monitorRangeList = rangeList;
    }
}

export default MainController;
